import React, { Component, Fragment, lazy, Suspense } from 'react';
import styles from './Index.module.scss';
import Reveal from '../../components/Reveal/Reveal';

// const Donate = lazy(() => import('../Donate/Donate'));
const IntroBlock = lazy(() => import('./IntroBlock/IntroBlock'));
const QuestionUsageBlock = lazy(() => import('./questionUsageBlock/questionUsageBlock'));
const UsageSteps = lazy(() => import('./usageSteps/usageSteps'));
const UsageCondition = lazy(() => import('./usageCondition/usageCondition'));
const Features = lazy(() => import('./features/features'));
const HomeMenuIntro = lazy(() => import('./homeMenuIntro/homeMenuIntro'));
const Members = lazy(() => import('./members/members'));
const AddBabyDragon = lazy(() => import('./addBabyDragon/addBabyDragon'));
const CopyRight = lazy(() => import('./copyRight/copyRight'));

class Index extends Component {
  render() {
    return(
      <Fragment>
        <Suspense fallback={ <div></div> }>
          <div className={styles.container}>
            <IntroBlock></IntroBlock>
            <Reveal><QuestionUsageBlock></QuestionUsageBlock></Reveal>
            <Reveal><UsageSteps></UsageSteps></Reveal>
            <Reveal><UsageCondition></UsageCondition></Reveal>
            <Reveal><Features></Features></Reveal>
            <Reveal><HomeMenuIntro></HomeMenuIntro></Reveal>
            <Reveal><Members></Members></Reveal>
            <Reveal><AddBabyDragon></AddBabyDragon></Reveal>
            <CopyRight></CopyRight>
          </div>
        </Suspense>

      </Fragment>
    )
  }
};

export default Index;


